import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ChatTab } from "@/components/assistant/ChatTab";
import { TicketsTab } from "@/components/assistant/TicketsTab";
import { MessageCircleQuestion, X } from "lucide-react";

export const AssistantWidget = () => {
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState("chat");
  const [unread, setUnread] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0);

  const loadUnread = useCallback(() => api.get("/support/unread").then((r) => setUnread(r.data.count)).catch(() => {}), []);
  useEffect(() => { loadUnread(); const t = setInterval(loadUnread, 60000); return () => clearInterval(t); }, [loadUnread]);

  const tabBtn = (k, label, badge) => (
    <button onClick={() => setTab(k)} data-testid={`assistant-tab-${k}`}
      className={`relative flex-1 py-2 text-xs font-semibold transition-colors ${tab === k ? "text-white" : "text-emerald-100/60 hover:text-white"}`}>
      {label}{badge > 0 && <span className="ml-1 rounded-full bg-rose-500 px-1.5 text-[10px] text-white">{badge}</span>}
      {tab === k && <span className="absolute inset-x-6 bottom-0 h-[2px] rounded-full bg-amber-400" />}
    </button>
  );

  return (
    <>
      {open && (
        <div data-testid="assistant-panel"
          className="fixed z-50 bottom-24 right-4 sm:right-6 w-[calc(100vw-2rem)] sm:w-[400px] h-[min(600px,calc(100vh-8rem))] flex flex-col overflow-hidden rounded-2xl bg-white shadow-[0_20px_60px_rgba(6,42,32,0.28)] ring-1 ring-zinc-200 animate-in fade-in slide-in-from-bottom-4 duration-200">
          <div className="bg-[#062a20] px-4 pt-3">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-semibold text-white">Yardım Asistanı</p>
                <p className="text-[11px] text-emerald-100/60">Yapay zekâ ile anında cevap</p>
              </div>
              <button onClick={() => setOpen(false)} data-testid="assistant-close" className="rounded-md p-1 text-emerald-100/70 hover:bg-white/10 hover:text-white"><X className="h-4 w-4" /></button>
            </div>
            <div className="mt-2 flex">{tabBtn("chat", "Asistan")}{tabBtn("tickets", "Taleplerim", unread)}</div>
          </div>
          <div className="flex-1 min-h-0">
            <div className={tab === "chat" ? "h-full" : "hidden"}><ChatTab onTicketCreated={() => setRefreshKey((k) => k + 1)} /></div>
            {tab === "tickets" && <TicketsTab refreshKey={refreshKey} onSeen={loadUnread} />}
          </div>
        </div>
      )}
      <button onClick={() => { if (!open) loadUnread(); setOpen((o) => !o); }} data-testid="assistant-toggle" aria-label="Yardım Asistanı"
        className="fixed z-50 bottom-5 right-4 sm:right-6 h-14 w-14 rounded-full bg-[#062a20] text-amber-400 shadow-[0_10px_30px_rgba(6,42,32,0.35)] ring-2 ring-amber-400/70 flex items-center justify-center hover:scale-105 active:scale-95 transition-transform duration-200">
        {open ? <X className="h-6 w-6" /> : <MessageCircleQuestion className="h-6 w-6" />}
        {!open && unread > 0 && <span className="absolute -top-1 -right-1 h-5 min-w-5 rounded-full bg-rose-500 px-1 text-[11px] font-bold text-white flex items-center justify-center" data-testid="assistant-unread">{unread}</span>}
      </button>
    </>
  );
};
